// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//  BURGUER MENU ----------------------------------------------------------------

	const menuBtn = document.getElementById('menu-btn');
	const navigation = document.querySelector('.navigation');
	const head = document.getElementById('header');
	
	menuBtn.addEventListener('click', function(event) {
		event.preventDefault();
		this.classList.toggle('active');
		navigation.classList.toggle('open');
		head.classList.toggle('open');
	});
	
	//mobile Menu
	const mobilemenuBtn = document.getElementById('js-burgerMenuBtn');
	const closeMenu = document.querySelector(".js-burger-close");
	if (mobilemenuBtn) {
		mobilemenuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			this.classList.toggle('active');
			navigation.classList.toggle('open');
			head.classList.toggle('open');
		});
		
	}
	if (closeMenu) {
		closeMenu.addEventListener('click', function(event) {
			event.preventDefault();
			this.classList.toggle('active');
			navigation.classList.toggle('open');
			head.classList.toggle('open');
		});
		
	}


	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}
	//// Forms animation for labels   ----------------------------------------------------------------
	//Email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}

	//scroll anchor links
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();
	
			document.querySelector(this.getAttribute('href')).scrollIntoView({
				behavior: 'smooth',
				block: "start"
			});
		});
	});


})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let header = document.getElementById('header');
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!header.classList.contains('down')){
				header.classList.add('down');
				header.classList.remove('up');
			}
		} else {
			// upscroll code
			if(!header.classList.contains('up')){
				header.classList.add('up');
				header.classList.remove('down');
			}
		}
	} else {
		if(header.classList.contains('up') || header.classList.contains('down')){
			header.classList.remove('up');
			header.classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}